import { useContext, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MobileContext } from "../../providers/MobileContext";
import styles from "./MainPage.module.scss";
import Layout from "../../Components/Layout/Layout";
import Search from "../../Components/Search/Search";
import default_thumbnail from "../../Assets/Images/logo01.png";
import Button from "../../Components/Button/Button";
import advertisement_1 from "../../Assets/Images/advertisement_1.png";
import advertisement_2 from "../../Assets/Images/advertisement_2.png";
import advertisement_3 from "../../Assets/Images/advertisement_3.png";
import Wrapper from "../../Components/Layout/Wrapper";
import BasicAPI from "../../API/BasicAPI";

const MainPage = () => {
  const navigate = useNavigate();
  const isMobile = useContext(MobileContext);
  const [articleList, setArticleList] = useState([]);

  useEffect(() => {
    BasicAPI({
      url: `${process.env.REACT_APP_SERVICE_URL}/article/articles/popular/`,
      method: "GET",
      success: (res) => setArticleList(res.data),
      fail: (res) => console.error(res),
    });
  }, []);

  return (
    <Layout>
      <Search />
      <div className={styles.popular_news}>
        <Wrapper>
          <div className={styles.title_left}>실시간 인기뉴스</div>
          <div
            className={styles.content_wrapper}
            style={{
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <div
              className={styles.article_wrapper}
              style={{ width: isMobile ? "100%" : "70%" }}
            >
              {articleList.map(
                (article, index) =>
                  index < 2 && (
                    <Link
                      to={`/article/articles/${article.id}`}
                      className={styles.article}
                      key={article.id}
                      style={{
                        flexDirection: isMobile ? "column" : "row",
                        height: isMobile ? "100%" : "22rem",
                      }}
                    >
                      <div
                        className={styles.thumbnail}
                        style={{ width: isMobile ? "100%" : "25%" }}
                      >
                        <img
                          className={
                            styles[!article.thumbnail && "no_thumbnail"]
                          }
                          src={
                            article.thumbnail
                              ? article.thumbnail
                              : default_thumbnail
                          }
                          alt="기사 썸네일 이미지"
                          style={{
                            borderRadius: isMobile
                              ? "1rem 1rem 0 0 "
                              : "1rem 0 0 1rem",
                          }}
                        />
                      </div>
                      <div
                        className={styles.text}
                        style={{ width: isMobile ? "100%" : "75%" }}
                      >
                        <p className={styles.article_title}>{article.title}</p>
                        <p className={styles.article_content}>
                          {article.content_text}
                        </p>
                        <p className={styles.article_date}>
                          {article.created_at}
                        </p>
                      </div>
                    </Link>
                  )
              )}
            </div>
            <div
              className={styles.rank_wrapper}
              style={{ width: isMobile ? "100%" : "30%" }}
            >
              {articleList.map(
                (article, index) =>
                  index >= 2 &&
                  index < 7 && (
                    <Link
                      to={`/article/articles/${article.id}`}
                      className={styles.rank_item}
                      key={article.id}
                    >
                      <div className={styles.rank_num}>{index + 1}</div>
                      <div className={styles.rank_article_wrapper}>
                        <div className={styles.article_title}>
                          {article.title}
                        </div>
                        <div className={styles.writer}>{article.reporter}</div>
                      </div>
                    </Link>
                  )
              )}
            </div>
          </div>
        </Wrapper>
      </div>
      <div className={styles.advertisement}>
        <Wrapper>
          <div className={styles.title_center}>지금 입점신청하세요</div>
          <div
            className={styles.box_wrapper}
            style={{ flexDirection: isMobile ? "column" : "row" }}
          >
            <div className={styles.box}>
              <div className={styles.bg_wrapper}>
                <img src={advertisement_1} alt="광고 배너 이미지" />
              </div>
              <div className={styles.text_wrapper}>
                <p className={styles.top_text}>정기 홍보기사 발행</p>
                <p className={styles.content_text}>
                  홍보배너가 삽입된 홍보기사가 정기적으로 업데이트 됩니다.
                </p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={styles.bg_wrapper}>
                <img src={advertisement_2} alt="광고 배너 이미지" />
              </div>
              <div className={styles.text_wrapper}>
                <p className={styles.top_text}>배너 관리</p>
                <p className={styles.content_text}>
                  기사에 실릴 홍보 배너를 자유롭게 지정, 교체, 관리하실 수
                  있습니다.
                </p>
              </div>
            </div>
            <div className={styles.box}>
              <div className={styles.bg_wrapper}>
                <img src={advertisement_3} alt="광고 배너 이미지" />
              </div>
              <div className={styles.text_wrapper}>
                <p className={styles.top_text}>콘텐츠 관리</p>
                <p className={styles.content_text}>
                  자사 페이지에 노출될 콘텐츠 내용을 직접 작성, 수정, 관리하실
                  수 있습니다.
                </p>
              </div>
            </div>
          </div>
          <Button
            type="blue"
            text="입점신청하기"
            onClick={() => navigate("/register_partner")}
          />
        </Wrapper>
      </div>
    </Layout>
  );
};

export default MainPage;
